import axios from 'axios';
import { REACT_APP_BASE_URL_FE } from 'config';
/**
 * Fetches the configuration from the server using the project key and user ID.
 * 
 * @returns {Promise<Object>} The configuration data or an empty object in case of an error.
 */
export const fetchConfig = async (userData) => {
  try {
    const { token, user } = userData || {};
    const response = await axios.request({
      method: "get",
      url: `${REACT_APP_BASE_URL_FE}user/get/env`,
      headers: {
        userId: user?.id || '',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching configuration:', error);
    return {};
  }
};